export const SESSION_EVENTS = {
  unauthorized: 'appSession:unauthorized',
};
